import { CalendarDefault } from './calendar-default.component';

export * from './calendar-default.component';
export default CalendarDefault;

CalendarDefault.define('der-tailormade-roundtrip-offer-calendar-default');

declare global {
    interface HTMLElementTagNameMap {
        'der-tailormade-roundtrip-offer-calendar-default': CalendarDefault;
    }
}
